export const siteNameGenerator = (organization, subLocation) => {
  const { name: orgName } = organization || {};
  const {
    nick_name: nickName,
    address,
    room,
    is_virtual: isVirtual,
  } = subLocation || {};

  if (isVirtual) {
    if (nickName && room) {
      return `${nickName} - ${room}`;
    }

    return room;
  }
  if (nickName && room) {
    return `${nickName} - ${room}`;
  }

  if (address && room) {
    return `${address} - ${room}`;
  }

  if (nickName) {
    return nickName;
  }

  if (address) {
    return address;
  }

  return orgName;
};

export const subLocationNameGenerator = (subLocation, isVirtual) => {
  const { nick_name: nickName, address, room } = subLocation || {};

  if (isVirtual) {
    if (nickName) {
      return `${nickName}`;
    }

    if (address) {
      return `${address}`;
    }
  } else {
    if (nickName && room) {
      return `${nickName} - ${room}`;
    }

    if (address && room) {
      return `${address} - ${room}`;
    }
  }

  if (nickName) {
    return nickName;
  }

  return address;
};
